export default "/images/vendor/flag-icons/flags/1x1/ch.svg?e6b520ab87791013063b8f6610917551";